//
// Software Name: Orange Design System Charts
// SPDX-FileCopyrightText: Copyright (c) 2023 - 2026 Orange SA
// SPDX-License-Identifier: MIT
//
// This software is distributed under the MIT license.
//
/**
 * ODSChartsMode defines the color mode for the charts
 */
export var ODSChartsMode;
(function (ODSChartsMode) {
    ODSChartsMode["LIGHT"] = "light";
    ODSChartsMode["DARK"] = "dark";
    ODSChartsMode["DEFAULT"] = "default";
})(ODSChartsMode || (ODSChartsMode = {}));
